/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue';
import App from './App.vue';
import router from './starterRouter';
import VueCalendly from 'vue-calendly';

Vue.config.productionTip = false;

Vue.use(VueCalendly);

import './assets/scss/custom.scss';

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
